import React from 'react'
import { RowLayout } from '../RowLayout'
import { translation } from '../../i18n'
import { strToDateFormat } from '../../helpers'
import { OverviewRowAttachments } from './OverviewRowAttachments'
import {
  AttachmentType,
  CaseCommonDataType,
  CasePARespType,
  DestinationType,
} from '../../models'

export type accidentOverviewRespType = {
  caseCommon?: CaseCommonDataType
  casePA?: CasePARespType
  destinations: DestinationType[]
} & translation

export const AccidentOverview = (params: accidentOverviewRespType) => {
  const t = params.t
  return (
    <>
      <RowLayout
        text={t('accidentForm.damageType.label')}
        data={t(`damageTypes.${params.casePA?.damageType}`)}
      />
      <RowLayout
        text={t('accidentForm.claimReported.label')}
        //@ts-ignore
        data={!!params.casePA?.claimReported ? t('yes') : t('no')}
      />
      {params.casePA?.claimReported === true && (
        <RowLayout
          text={t('accidentForm.claimNumber.label')}
          data={params.casePA?.claimNumber}
        />
      )}
      <RowLayout
        text={t('accidentForm.occurredOn.label')}
        data={strToDateFormat(params.caseCommon?.occurredOn)}
      />
      <RowLayout
        text={t('accidentForm.destination.label')}
        data={
          params.destinations.find(
            (item: DestinationType) =>
              item.code === params?.caseCommon?.destination
          )?.name ?? params?.caseCommon?.destination
        }
      />
      <RowLayout
        text={t('accidentForm.resort.label')}
        data={params.caseCommon?.resort}
      />
      <RowLayout
        text={t('accidentForm.place.label')}
        data={params.caseCommon?.place}
      />
      <RowLayout
        text={t('accidentForm.assistance.label')}
        // @ts-ignore
        data={params.caseCommon?.assistance ? t('yes') : t('no')}
      />
      {params.caseCommon?.assistance === false && (
        <RowLayout
          text={t('accidentForm.assistanceDesc.label')}
          data={params.caseCommon?.assistanceDesc}
        />
      )}
      <RowLayout
        text={t('accidentForm.treatedAbroad.label')}
        //@ts-ignore
        data={!!params.casePA?.treatedAbroad ? t('yes') : t('no')}
      />
      {params.casePA?.treatedAbroad === true && (
        <RowLayout
          text={t('accidentForm.treatmentFacility.label')}
          data={params.casePA?.treatmentFacility}
        />
      )}
      {params.caseCommon?.description !== '' && (
        <RowLayout
          text={t('accidentForm.description.label')}
          data={params.caseCommon?.description}
        />
      )}
      <RowLayout
        text={t('accidentForm.homeDoctorName.label')}
        data={params.casePA?.homeDoctorName}
      />
      <RowLayout
        text={t('accidentForm.homeDoctorContact.label')}
        data={params.casePA?.homeDoctorContact}
      />
      {params.casePA?.attachmentList && (
        <React.Fragment>
          <OverviewRowAttachments
            text={t('attachments.CASEPA.MEDICPL')}
            attachmentList={params.casePA?.attachmentList}
            attachmentType={AttachmentType.MEDICPL}
          />
          <OverviewRowAttachments
            text={t('attachments.CASEPA.MEDICABROAD')}
            attachmentList={params.casePA?.attachmentList}
            attachmentType={AttachmentType.MEDICABROAD}
          />
          <OverviewRowAttachments
            text={t('attachments.CASEPA.REPORT')}
            attachmentList={params.casePA?.attachmentList}
            attachmentType={AttachmentType.REPORT}
          />
          <OverviewRowAttachments
            text={t('attachments.CASEPA.OTHER')}
            attachmentList={params.casePA?.attachmentList}
            attachmentType={AttachmentType.OTHER}
          />
        </React.Fragment>
      )}
    </>
  )
}
